import React from "react";
import LoadingIcon from '../assets/Eclipse-1s-400px.svg'

export default function LoaderScreen({ message = "Loading..." }) {
  return (
    <div style={{ textAlign: "center", color: "#fff" }}>
      <img
        src={LoadingIcon}
        alt="Loading..."
        style={{ width: "120px", height: "120px", marginBottom: "50px" }}
      />
      <h4>{message}</h4>
    </div>
  );
}